export default __webpack_public_path__ + "static/media/CVpolaroid_DevonportColumn.8472e4bc.png";